import React, { ChangeEvent } from 'react'
import { useStoreActions, useStoreState } from 'store'
import { SortBy as SortByModel } from 'types/offers'

const options = [
  { value: '', label: 'Relevance' },
  { value: 'rate', label: 'Low rate' },
  { value: 'apr', label: 'Low APR' },
  { value: 'payment', label: 'Low monthly payment' },
  { value: 'fees', label: 'Low upfront costs' },
]

export default function SortByFilter() {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { sortBy } = useStoreState(actions => actions.offers)
  const { setSortBy } = useStoreActions(actions => actions.offers)

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value as SortByModel
    setSortBy(value)
    onInputTracking({ name: 'sort', label: 'sort by', type: 'SORT', value })
  }

  return (
    <>
      <div className="FormControl" style={{ maxWidth: 'initial' }}>
        <label className="FormLabel" htmlFor="sort-filter">
          Sort by
        </label>
        <select
          id="sort-filter"
          value={sortBy}
          className="FormSelect font-circular-book type-body-two text-black"
          onChange={handleChange}
          data-testid="sort-filter"
          style={{ paddingTop: '0.22222rem', height: '0' }}
        >
          {options.map((option: { value: string; label: string }) => (
            <option key={`sort-${option.label}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="FormSelect-arrow Icon Icon--xs">
          <svg
            className="Icon-glyph"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="-1 -2 8 8"
            aria-hidden="true"
          >
            <title>Arrow icon</title>
            <path d="M.707 0L0 .697 3.354 4 6.707.697 6 0 3.359 2.602z" fillRule="evenodd" />
          </svg>
        </span>
      </div>
    </>
  )
}
